import { IconBlock, Skeleton, Text } from '@bbl-digital/snorre'
import { useTheme } from '@emotion/react'
import { FC } from 'react'
import { useGetPortalUserSummaryQuery } from 'shared/microServices/client/client.service'
import { Wrapper } from './styles'

interface IProps {
  overrideMessage?: string
  term?: string
  // Suffix for term e.g. person + "er"
  termSuffix?: string
  align?: 'left' | 'center' | 'right'
  loading?: boolean
  noMargin?: boolean
}

const ReservedUsersComponent: FC<IProps> = ({
  term,
  termSuffix,
  align = 'left',
  loading,
  noMargin = false,
  overrideMessage,
}) => {
  const { info } = useTheme()
  const { data: summary, isLoading: summaryLoading } =
    useGetPortalUserSummaryQuery(undefined, { skip: !!overrideMessage })

  const reservedCount =
    summary?.reservedAgainstElectronicCommunicationCount || 0

  if ((summaryLoading || loading) && !overrideMessage) {
    return (
      <Wrapper align={align} noMargin={noMargin}>
        <Skeleton height="24px" />
      </Wrapper>
    )
  }

  const defaultTerm = `person${
    reservedCount > 1 || reservedCount === 0 ? 'er' : ''
  }`

  const termWithSuffix = term
    ? termSuffix
      ? `${term}${reservedCount > 1 || reservedCount === 0 ? termSuffix : ''}`
      : term
    : defaultTerm

  const message = `${reservedCount} ${termWithSuffix} har reservert seg mot elektronisk
    kommunikasjon`

  return (
    <Wrapper align={align} noMargin={noMargin}>
      <IconBlock color={info} />
      <Text italic>{overrideMessage || message}</Text>
    </Wrapper>
  )
}

export default ReservedUsersComponent
